import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { Linking, SafeAreaView, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { Button } from 'react-native-elements';
import { appTheme } from '@/config/colors';

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  container: {
    flex: 1,
    alignItems: 'center',
  },

  textButtonWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
});

function Anleitung(props) {
  const responsiveFontSize = useResponsiveFontSize(1);

  const getResponsiveFontSize = (factor) => {
    return responsiveFontSize * factor;
  };

  let responsiveStyles = StyleSheet.create({
    buttonStyle: {
      marginVertical: getResponsiveFontSize(1),
      backgroundColor: appTheme.primary,
      maxWidth: 400,
      padding: getResponsiveFontSize(1),
    },
    buttonTitleStyle: {
      fontSize: getResponsiveFontSize(1.5),
    },
    textStyle: {
      fontSize: getResponsiveFontSize(2),
      fontWeight: '700',
    },
  });

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.container}>
        <View style={styles.textButtonWrapper}>
          {props?.route?.params?.therapist == 1 ? (
            <Text style={responsiveStyles.textStyle}>
              Die Gebrauchsanweisung für Therapeut:innen finden Sie hier:
            </Text>
          ) : (
            <Text style={responsiveStyles.textStyle}>
              Die Gebrauchsanweisung für Patient:innen finden Sie hier:
            </Text>
          )}
          <Button
            title="Anleitung im Browser öffnen"
            buttonStyle={responsiveStyles.buttonStyle}
            titleStyle={responsiveStyles.buttonTitleStyle}
            onPress={() =>
              Linking.openURL(
                props?.route?.params?.therapist == 1
                  ? 'https://neolexon.de/wp-content/uploads/2021/10/gebrauchsanweisung-neolexon-therapeuten-app-kurz.pdf'
                  : 'https://neolexon.de/wp-content/uploads/2021/10/gebrauchsanweisung-neolexon-aphasie-app-kurz.pdf',
              )
            }
          />
        </View>
      </View>
    </SafeAreaView>
  );
}

export default Anleitung;
